// Supabase Auth restituisce i messaggi sempre in inglese: traduciamo quelli
// che un cliente può incontrare. Per tutto il resto un messaggio generico,
// mai il testo originale in inglese.
const TRANSLATIONS: [RegExp, string][] = [
  [/invalid login credentials/i, 'Email o password non corretti.'],
  [/email not confirmed/i, "Devi prima confermare l'email: controlla la tua casella di posta."],
  [/user already registered|already been registered/i, 'Esiste già un account con questa email. Prova ad accedere.'],
  [/password should be at least/i, 'La password deve contenere almeno 8 caratteri.'],
  [/unable to validate email|invalid email|email address .* is invalid/i, "L'indirizzo email non è valido."],
  [/rate limit|too many requests|security purposes/i, 'Troppi tentativi. Attendi qualche minuto e riprova.'],
  [/signups? not allowed|signup is disabled/i, 'Le registrazioni sono momentaneamente disattivate.'],
  [/network|failed to fetch/i, 'Problema di connessione. Controlla la rete e riprova.'],
  [/invalid totp|invalid mfa|code .*(invalid|expired)/i, 'Codice non valido o scaduto. Riprova.'],
];

export function translateAuthError(message: string | undefined | null): string {
  if (!message) return 'Si è verificato un errore. Riprova.';
  for (const [pattern, translation] of TRANSLATIONS) {
    if (pattern.test(message)) return translation;
  }
  // I messaggi generati da noi sono già in italiano: li lasciamo passare.
  if (/[àèéìòù]|\b(il|la|non|deve|già|una?)\b/i.test(message)) return message;
  return 'Si è verificato un errore. Riprova.';
}
